const AcaoEnum = {
    NOTHING: 0,
    LOAD: 1,
    REMOVER: 2,
    ERRO: 9
}

export default AcaoEnum;